export default {
    props: {
        location: {
            type: Array,
            default: undefined,
            kComposite: 'location'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        tooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.autoHide'
        },
        tooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.close.effects'
        },
        tooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.close.duration'
        },
        tooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.open.effects'
        },
        tooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.open.duration'
        },
        tooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.content'
        },
        tooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.content.url'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.callout'
        },
        tooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.iframe'
        },
        tooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.height'
        },
        tooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.width'
        },
        tooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.position'
        },
        tooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.showAfter'
        },
        tooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.showOn'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMapMarker/MarkerProps.js